let loaded = false;

export const useRecentlyViewed = () => {
  const MAX_ITEMS = 12
  const viewedSet = useState('recently-viewed-list', () => new Set())

  const saveToLocalStorage = () => {
    if (import.meta.client) {
      localStorage.setItem('recently_viewed_list', JSON.stringify([...viewedSet.value]))
    }
  }

  const loadFromLocalStorage = () => {
    if (import.meta.client && !loaded) {
      const saved = localStorage.getItem('recently_viewed_list')
      viewedSet.value = saved ? new Set(JSON.parse(saved)) : new Set()
      loaded = true
    }
  }

  const addToRecentlyViewed = (uuid) => {
    // If the item already exists, move it to the end (most recent)
    if (viewedSet.value.has(uuid)) {
      viewedSet.value.delete(uuid)
    }

    // If at max limit, remove the oldest
    if (viewedSet.value.size >= MAX_ITEMS) {
      const oldest = viewedSet.value.values().next().value
      viewedSet.value.delete(oldest)
    }

    // Add as newest
    viewedSet.value.add(uuid)
    saveToLocalStorage()
  }

  const clearRecentlyViewed = () => {
    viewedSet.value.clear()
    saveToLocalStorage()
  }

  const isRecentlyViewed = (uuid) => viewedSet.value.has(uuid)

  // Reverse so the most recently added item appears first in UI
  const recentlyViewedList = computed(() => Array.from(viewedSet.value).reverse())

  onMounted(() => {
    loadFromLocalStorage()
  })

  if (import.meta.client) {
    window.addEventListener('storage', (event) => {
      if (event.key === 'recently_viewed_list') {
        loadFromLocalStorage()
      }
    })
  }

  return {
    recentlyViewedList,
    addToRecentlyViewed,
    clearRecentlyViewed,
    isRecentlyViewed,
  }
}
